export class AbortError extends Error {
    type = 'aborted';
    name = 'AbortError';
    constructor(cause?: Error | undefined) {
        // @ts-expect-error 2554
        super('Aborted', cause);
    }
}

export function checkAbort(
    opts?: AbortSignal | { signal?: AbortSignal }
): void {
    if (!opts) return;
    const signal = opts instanceof AbortSignal ? opts : opts.signal;
    if (!signal) return;
    if (signal.aborted) throw new AbortError();
}

function isObject(input: unknown): input is any {
    if (typeof input !== 'object' || input === null) return false;
    return true;
}

export function isAbortError(error: unknown) {
    if (!isObject(error)) return false;
    return error.name === 'AbortError' || error.name === 'CanceledError';
}

export function rethrowAbort(error: unknown) {
    if (isAbortError(error)) {
        throw error;
    }
}
